let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cp1kc")).then(() => parcelRequire('eoxiv'));